import { Checkbox, DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutWorkersCompensationReport extends Layout {
    checkboxExcludeNonTaxable: Checkbox;
    checkboxIncludeCrossYear: Checkbox;
    checkboxIncludeSsn: Checkbox;
    excludabletextboxDivisions: ExcludableTextbox;
    excludabletextboxJobClasses: ExcludableTextbox;
    excludabletextboxPayees: ExcludableTextbox;
    excludabletextboxTerminals: ExcludableTextbox;
    sourceWorkersCompensation: DataSource;
    switchReportType: Switch;
    textboxCheckDateRange: Textbox;
}
